module.exports = __webpack_public_path__ + "static/adobe-stock-278687683-f85266f6d18c35991ad4539beae4015c.jpg";